import { PRIVATE_API_ROUTES } from "../constants";
import Http from "./http-service";

import { getLocalizedMessage } from "../UtilityFunctions/utils";
import { showNotification } from "../UtilityFunctions/notification";

class RolesServices {
  static async getRoles({ params, intl }) {
    return Http.get(PRIVATE_API_ROUTES.ALL_ROLES, params)
      .then(({ data }) => {
        return Promise.resolve(data?.data?.result);
      })
      .catch((err) => {
        showNotification(
          "error",
          "Error",
          getLocalizedMessage(intl, "error.somethingWentWrong")
        );
        return Promise.reject(err);
      });
  }
}

export default RolesServices;
